<template>
    <div>
            <div class="col-md-12 col-xs-12 wrapper-box">
            
            <div class="col-sm-12 col-md-8 col-lg-7 col-xs-12 remove-margins" >
              
                <h3 style="margin-bottom:0px;">Profile Title <span class="red-star" data-toggle="popover" data-trigger="hover" data-placement="top" data-container="body" data-content="Required to publish your profile">★</span></h3>
               
                
                <input class="form-control" type="text" v-on:change="somethingChanged()" placeholder="Title: e.g your trusted dog buddy!" v-model="sitterProfile.Title">
                 <h3 style="margin-bottom:0px;">Info about yourself <span class="red-star" data-toggle="popover" data-trigger="hover" data-placement="top" data-container="body" data-content="Required to publish your profile">★</span></h3>
                  <p class="small">introduce yourself and let Pet parents know you better, take your time tell them why you are their best sitter</p>
                <textarea v-on:change="somethingChanged()" class="form-control" type="text" rows="5" placeholder="Describe yourself and add anything you want about your work and prevoius pet experiences" v-model="sitterProfile.AboutMe"> </textarea>
             
            <h3>Background Image <span class="red-star" data-toggle="popover" data-trigger="hover" data-placement="top" data-container="body" data-content="Required to publish your profile">★</span></h3>
            <UploadBackgroundPhoto></UploadBackgroundPhoto>
            </div>
            
            <div class="col-sm-12 col-xs-12 remove-margins">
                
                <h3 style="margin-bottom:0px; margin-top:0px;">Profile Image, minimum 1 personal <span class="red-star" data-toggle="popover" data-trigger="hover" data-placement="top" data-container="body" data-content="Required to publish your profile">★</span></h3>
                <p class="small">To make your profile standout upload 3 or more photos.</p>
                <div  class="images-custom-container">
                    <div v-if="sitterPhotoList!=0" v-for="photo, index in sitterPhotoList" class="image-class">
                                <ProfilePhotoView :photoIdProp="photo.SitterPhotoId"  :index="index" :key="photo.SitterPhotoId"></ProfilePhotoView>
                                <span class="close" @click="deleteImage(photo)"><i class="fa fa-trash" title="Delete this photo"></i></span>
                    </div>
               
                    <div class="image-class">
                        <UploadAddMore></UploadAddMore>
                    </div>
                    
                </div>
                
                
                
          
                </div>
                <div class="col-sm-8 col-xs-12 remove-margins" v-if="sitterProfile">
                
              

                <div v-if="sitterProfile.HomeDetailDto">
                <h3 style="margin-bottom:0px; padding-bottom:0px;">Home Details</h3>
                
                <li style="margin-top:0px; padding-top:0px;"  class="checkbox" >
                    <label class="h5">
                            <input v-on:change="somethingChanged()" type="checkbox" v-model="sitterProfile.HomeDetailDto.IsHasChildren">
                             Children under 10 years at Home</label>
                </li>
                
                <li class="checkbox">
                    <label class="h5">
                            <input v-on:change="somethingChanged()" type="checkbox" v-model="sitterProfile.HomeDetailDto.IsSmokeFree">
                             Smoke Free Household</label>
                </li>
                    
                <li class="checkbox">
                    <label class="h5"> 
                            <input v-on:change="somethingChanged()" type="checkbox" v-model="sitterProfile.HomeDetailDto.IsHasDog">
                             I have resident Dog at home</label>
                </li>

                <li class="checkbox">
                    <label class="h5">
                            <input v-on:change="somethingChanged()" type="checkbox" v-model="sitterProfile.HomeDetailDto.IsHasCat">
                             I have resident Cat at home</label>
                </li>
                <h3>Home Type</h3>
         
                <select v-on:change="somethingChanged()" class="form-control" v-model="sitterProfile.HomeDetailDto.HomeType">
                        <option  v-for="homeType in homeTypes" v-bind:value="homeType.value">
                            {{homeType.text}}
                        </option>
                </select>
                </div>
         
                <h3>Location Details <span class="red-star" data-toggle="popover" data-trigger="hover" data-placement="top" data-container="body" data-content="Required to publish your profile">★</span></h3>
         
                <select v-on:change="somethingChanged()" v-if="citiesList" class="form-control" v-model="sitterProfile.SitterLocationDto.CityId">
                        <option value="null" disabled selected hidden>{{selectCityComp}}</option>
                        <option  v-for="city in citiesList" v-bind:value="city.CityId">
                            {{city.CityName}}
                        </option>
                </select>

                <div style="margin-top:5px;" class="form-location" v-if="(!areasList || areasList.length==0)">
                            <div class='form-group'>
                                <select  class="form-control input-text">
                                      <option value="null" disabled selected hidden>Select your neighbor</option>
                                </select>
                            </div>
                        
                </div>
                <select v-on:change="somethingChanged()" v-if="areasList" style="margin-top:5px;"  class="form-control" v-model="sitterProfile.SitterLocationDto.AreaId">
                       <option value="null" disabled selected hidden>Select your neighbor</option>
                        <option v-for="area in areasList" v-bind:value="area.AreaId">
                            {{area.AreaName}}
                        </option>
                </select>
           
                </br>

                </div>
                <div class="col-sm-12" style="margin:0px; padding:0px;">
                    <div class="col-lg-8 col-md-10 col-sm-12 col-xs-12" style="margin:0px; padding:0px;" >
                        <button style="margin-top:20px; margin-left:0px;" class="btn  large-pad btn-success btn-block btn-lg" @click="updateSitterProfile()">{{saveChanges}}</button>
                    </div>
                </div>
            
        </div>
            
    </div>
</template>

<script>
  
import Vue from 'vue'
import sitterApi from '../../../services/sitterApi'
import router from '../../../router'
import auth from '../../../auth'
import store from '../../../data/store'
import commonApi from '../../../services/commonApi'
import ProfilePhotoView from './ProfilePhotoView.vue'
import UploadBackgroundPhoto from './UploadBackgroundPhoto.vue'
import UploadAddMore from './UploadAddMore'

export default {
    name: 'about',
    components:{
        UploadBackgroundPhoto,
        ProfilePhotoView,
        UploadAddMore,
        
        
    },
    data() {
        return {
            saveChanges: "Save Changes",
            editing: false,
            backgroundImage: false,
            homeTypes:[
            {text:'Studio Apartment', value:0},
            {text:'1 Bedroom Apartment', value:1},
            {text:'2 Bedroom Apartment', value:2},
            {text:'3 Bedroom Apartment', value:3},
            {text:'4 Townhouse', value:4},
            {text:'5 Villa', value:5},
            ],
           
                
            
        }
        
    },
    watch:{
        'sitterProfile.SitterLocationDto.CityId': function(cityId){
            commonApi.getAreasList(cityId)
            
        }
    },
    update: function(){
         $('[data-toggle="popover"]').popover();
    },
    methods: {
        updateSitterProfile: function () {
            var self = this
            if (!self.sitterProfile.Title || !self.sitterProfile.AboutMe)
                {
                    swal("Title or About Me incomplete", "Please fill in title and about me fields","info")
                    return
                }
            if (self.sitterProfile.SitterLocationDto.CityId == null || self.sitterProfile.SitterLocationDto.CityId==null){
                    swal("Location missing", "Please fill set your location details","info")
                    return
            }
            self.saveChanges = "Saved"
            self.editing = false
            sitterApi.updateSitterProfile().then(function (data){
                 self.$parent.updateProfileStatus();
                 if (self.profileReadyComp==false)
                   router.push({ path: '/sitter-profile-edit/petpreferences'});

            }).fail(function(error){
                console.log(error)
                swal("Save failed", error.responseJSON.Message, "error")
            })
           
        },
        somethingChanged: function(){
            this.editing=true
            this.saveChanges = "Changes Pending Save"
        },
        deleteImage: function(photo){
        var self = this
        $.ajax("https://www.dupaws.com/services/api/deletePhoto/" + photo.SitterPhotoId, {
                    type: 'POST',
                    beforeSend: function(xhr){
                        xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
                    },
                    dataType:"json",
                    contentType: "application/json; charset=utf-8",
                    crossDomain: true,
                    success: function () {
                        store.commit('deleteSitterPhoto', photo)
                        self.$parent.updateProfileStatus()
                    },
                    error: function (error) {
                        swal("Oops", error.responseJSON.Message,"info")
                    }
        });
      },
      
        
    },
    mounted: function(){
        var self = this
        this.$ga.page(this.$router)
        if (!store.getters.authenticated && !localStorage.getItem('access_token')) {
            router.router.push({ path: '/login', query: { redirect: 'sitterprofile/about' } })
        }

        sitterApi.getSitterProfile()        


        if (!store.getters.SitterPhotos){
            sitterApi.getSitterPhotos()
        } 

    },
    computed: {
        selectCityComp: function(){
            if (store.getters.CountryData.CountryId!=9){
                return 'Select your city'
            } else {
                return 'Select your area'
            }
        },
        sitterProfile: function(){
            return store.getters.SitterProfile
        },
        citiesList: function(){
            return store.getters.CitiesList
        },
        areasList: function(){
          return store.getters.AreasList
        },
        sitterPhotoList: function(){
            return store.getters.SitterPhotos
            
        },
        profileReadyComp: function(){
            return this.$parent.profileStatus.IsProfileReady
        }
    },
   
  

}

</script>

<style scoped>


.images-custom-container{
    display:flex; 
    flex-wrap:wrap;
    /*justify-content:flex-end;*/

}

.image-class {
    position:relative;
    
}

.image-class:hover .close {
    opacity: 1;
}


.image-class .close {
    position:absolute;
    top: 2px;
    right:2px;
    background-color: #FFF;
    padding: 3px 2px 2px;
    color: #000;
    font-weight: bold;
    cursor: pointer;
    border-radius: 50%;
}

</style>


// WEBPACK FOOTER //
// AboutMe.vue?e55982e6